import { render } from "./magic-remote-multimadia.vue?vue&type=template&id=323d899f&scoped=true&ts=true"
import script from "./magic-remote-multimadia.vue?vue&type=script&lang=ts"
export * from "./magic-remote-multimadia.vue?vue&type=script&lang=ts"

import "./magic-remote-multimadia.vue?vue&type=style&index=0&id=323d899f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-323d899f"]])

export default __exports__